export default __webpack_public_path__ + "static/media/045-brooch.b8bd067e.svg";